import Hero from "@/components/Hero";
import ServicesSection from "@/components/ServicesSection";
import HowItWorks from "@/components/HowItWorks";
import WhereWeShip from "@/components/WhereWeShip";
import SocialFeed from "@/components/SocialFeed";
import Testimonials from "@/components/Testimonials";
import MerchantStrip from "@/components/MerchantStrip";

const Home = () => (
  <>
    <Hero />
    <ServicesSection />
    <MerchantStrip />
    <HowItWorks />
    <WhereWeShip />
    <SocialFeed />
    <Testimonials />
  </>
);

export default Home;
